import { Badge } from '@flote/ui';
import type { AdminPartitionFulfillmentType } from '@flote/contracts/http';

interface PartitionTypeBadgeConfig {
  label: string;
  className: string;
}

const PARTITION_TYPE_CONFIG: Record<AdminPartitionFulfillmentType, PartitionTypeBadgeConfig> = {
  brand_driver: {
    label: 'Brand Driver',
    className: 'bg-purple-100 text-purple-800 border-purple-200 hover:bg-purple-100',
  },
  flote_driver: {
    label: 'Flote Driver',
    className: 'bg-sky-100 text-sky-800 border-sky-200 hover:bg-sky-100',
  },
  mail_carrier: {
    label: 'Mail Carrier',
    className: 'bg-orange-100 text-orange-800 border-orange-200 hover:bg-orange-100',
  },
};

interface PartitionTypeBadgeProps {
  type: AdminPartitionFulfillmentType | null;
  className?: string;
}

export function PartitionTypeBadge({ type, className }: PartitionTypeBadgeProps) {
  if (!type) {
    return (
      <Badge className={`bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-100 ${className ?? ''}`}>
        Unassigned
      </Badge>
    );
  }

  const config = PARTITION_TYPE_CONFIG[type] ?? {
    label: type,
    className: 'bg-gray-100 text-gray-800 border-gray-200',
  };

  return (
    <Badge className={`${config.className} ${className ?? ''}`}>
      {config.label}
    </Badge>
  );
}
